import BaseApi from './base-api';
import {ApiPaths, OauthAdsAPIPath, OauthAPIPath} from './const';

class AppApi extends BaseApi {
  getBindingInfo(apiPath, params) {
    const url = `${window.runtime_configs.REACT_APP_API_ENDPOINT}${apiPath}`;
    const body =  JSON.stringify(params);
    return this.call("GET", {}, url, body);
  }
  getBindingStatus(apiPath) {
    return this.request(apiPath, {}, "GET");
  }
  sendOtp(params) {
    return this.request(ApiPaths.SEND_OTP, params);
  }
  verifyOtp(params) {
    return this.request(ApiPaths.VERIFY_OTP, params);
  }
  confirmBinding(params) {
    return this.request(ApiPaths.CONFIRM_BINDING, params);
  }
}

class OauthAPI extends BaseApi{
  getBinding(bindingID) {
    const url = `${window.runtime_configs.REACT_APP_API_V2_ENDPOINT}${OauthAPIPath}${bindingID}`
    return this.call("GET", {}, url);
  }

  getAds(bindingID) {
    const url = `${window.runtime_configs.REACT_APP_API_V2_ENDPOINT}${OauthAdsAPIPath}${bindingID}`
    return this.call("GET", {}, url);
  }
}

const AppApiInstance = new AppApi();

const OauthAPIInstance = new OauthAPI();

export { BaseApi, AppApiInstance, OauthAPIInstance };
